import {XCircleIcon} from '@primer/octicons-react'
import {Button} from '@primer/react'
import {Link} from '@github-ui/react-router'

import {ForYouItem} from '../shared/ForYouItem'
import {ForYouLeadingIcon} from '../shared/ForYouLeadingIcon'
import {useFailedChecksData, type FailedRequiredCheck} from './use-failed-checks-data'

// Surfaces each failed required status check as its own item. The parent
// ForYouItemBoundary decides which subsection (and thus which viewer) sees it via
// its `audience` prop, so this component stays audience-agnostic.
export function FailingChecks() {
  const failedChecks = useFailedChecksData()

  if (!failedChecks || failedChecks.length === 0) {
    return null
  }

  return (
    <>
      {failedChecks.map(check => (
        <FailedCheckItem key={check.key} check={check} />
      ))}
    </>
  )
}

function FailedCheckItem({check}: {check: FailedRequiredCheck}) {
  return (
    <ForYouItem
      leadingVisual={<ForYouLeadingIcon icon={XCircleIcon} variant="danger" />}
      title={check.name}
      itemName="failed-check"
      description={check.detailText}
      actionSlot={
        check.targetUrl ? (
          <Button as={Link} to={check.targetUrl} size="small" aria-label={`View details for ${check.name}`}>
            View details
          </Button>
        ) : undefined
      }
    />
  )
}
